<template>
	<div class="wrapper login">
		<div class="upper">
			<div class="image-wrapper">
				<img src="../assets/img/bulevar-promo.svg" alt="Bulevar Logo" />
			</div>
			<p>{{ t('txt_slogan') }}</p>
			<p><button @click="openPopup('2024112210211478429')" class="outline">{{ t('txt_about_bulevar_button') }}</button></p>
		</div>
		<div class="bottom">
			<div class="checkbox-wrapper-15 mb-5" ref="gdprwrap">
				<input class="inp-cbx" id="gdpr" ref="gdpr" name="gdpr" type="checkbox" style="display: none;"/>
				<label class="cbx" for="gdpr">
					<span></span>
					<span v-html="t('txt_gdpr_statement')"></span>
				</label>
			</div>
			<button @click="handleLogin()" class="button">{{ t('txt_continue_email') }}</button>
			<div class="button-wrap">
				<button @click="handleLogin('google')" class="button google"><span class="visually-hidden">GOOGLE</span><!-- {{ t('txt_continue_google') }} --></button>
				<button @click="handleLogin('facebook')" class="button facebook"><span class="visually-hidden">FACEBOOK</span><!-- {{ t('txt_continue_facebook') }} --></button>
			</div>
			<p class="text-center small"><a href="#" @click="openPopup('2024121808443571433')" class="link">{{ t('txt_required_permisions') }}</a></p>
		</div>
	</div>
	<div v-if="state.show" class="fullscreen-popup">
		<button @click="closePopup" class="close"><span class="visually-hidden">Close</span></button>
		<div class="popup-content">
			<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" />
			<h1>{{ state.title }}</h1>
			<div v-html="state.description" class="description"></div>
		</div>
	</div>
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '../utils/axios';

export default {
	name: 'LoginPage',
	data() {
		return {
			isAuthenticated: false,
			userData: false,
			localesRemap: {
				'sl' : 'si',
				'en' : 'en',
				'it' : 'it'
			},
			state: {
				show: false
			}
		};
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	methods: {
		openPopup(contentId) {
			const lang = localStorage.getItem('lang') || 'en';
			const apiUrl = `/${lang}/api/content/${contentId}/view`;
			
			apiClient.get(apiUrl, {noAuth:true})
				.then(response => {
					this.state.title = response.data.title;
					this.state.description = response.data.description;
					this.state.show = true;
					console.log(this.state)
			}).catch(apiError => {
					console.error('Failed to send user data:', apiError);
					this.loading = false;
			});
		},
		closePopup() {
			this.state.show = false;
		},
		rerunAnimation() {
			this.$refs.gdprwrap.classList.remove('animate__animated');
			this.$refs.gdprwrap.classList.remove('animate__headShake');
			
			this.$refs.gdprwrap.offsetWidth;
			
			this.$refs.gdprwrap.classList.add('animate__animated');
			this.$refs.gdprwrap.classList.add('animate__headShake');
		},
		handleLogin(idpHint) {
			this.$refs.gdprwrap.classList.remove('animate__animated');
			this.$refs.gdprwrap.classList.remove('animate__headShake');
			if(this.$refs.gdpr.checked){
				keycloak.login({ 
					idpHint,
					locale: this.localesRemap[localStorage.getItem('lang')]
				}).then(() => {
						this.isAuthenticated = true;
						const userData = {
							username: keycloak.tokenParsed.preferred_username,
							last_name: keycloak.tokenParsed?.family_name || 'Surname',
							first_name: keycloak.tokenParsed?.given_name || 'Name',
							email: keycloak.tokenParsed.email,
							keycloak_id: keycloak.tokenParsed.sub
						};
						apiClient.post('/'+localStorage.getItem('lang')+'/api/user', userData)
							.then(response => {
								this.userData = response.data;
								this.$router.push('/profile');
							})
							.catch(apiError => {
								console.error('Failed to send user data:', apiError);
							});

					})
					.catch(error => {
						console.error('Login failed:', error);
					});
			} else {
				this.rerunAnimation();
				return true;
			}
		}
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if(!localStorage.getItem('lang')){
			this.$router.push('/');
		}
		if (this.isAuthenticated) {
			const userData = {
				username: keycloak.tokenParsed.preferred_username,
				last_name: keycloak.tokenParsed?.family_name || 'Surname',
				first_name: keycloak.tokenParsed?.given_name || 'Name',
				email: keycloak.tokenParsed.email,
				keycloak_id: keycloak.tokenParsed.sub
			};
			apiClient.post('/'+localStorage.getItem('lang')+'/api/user', userData)
				.then(response => {
					this.userData = response.data;
					if(response.data.country_iso_code != null){
						this.$router.push('/profile');
					} else {
						this.$router.push('/questionare');
					}
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
				});
		}
	}
};
</script>

<style>


button {
	margin-top: 10px;
}
</style>